import React from 'react'

const Footer = () => {
    return (
        <footer id="lfooter">
            <p style={{
                    fontSize: "1rem",
                    fontWeight: "400",
                    fontFamily: "'Lato', sans-serif",
                    lineHeight: "3.5vh",
                    textAlign: "center",
                    color: "#31333599",
                    
                }}>Developed By EMS Team. © Copyright 2021</p>
        </footer>
    )
}

export default Footer